import * as angular from "angular";
import { AdvancedSearchResult } from "../ts/rlAdmin.models";
import * as Models from "../ts/rlAdmin.models";

/*
 * extension actions for $resource classes
 */
export var RLActionDescriptions = {
    post: { method: "POST" },
    postArray: { method: "POST", isArray: true },
    getArray: { method: "GET", isArray: true },
    postSearch: {
        method: "POST",
        isArray: false,
        interceptor: {
            response: (res) => {
                return angular.extend(new AdvancedSearchResult(), res.data);
            }
        }
    },
};


/*
 * Exposes extension actions on $resource class
 */
export interface IRLResourceClass<T> {
    post(dataOrParams?: any): Models.IPromised<T>;
    postArray(dataOrParams?: any): Models.IPromised<T[]>;
    // sorry hovany
    // this uses a special action description (see above) to construct objects
    // this allows methods on them to be used.
    // it would be great to generalize this for all classes <T>
    postSearch(dataOrParams?: any): Models.IPromised<T>;
    get(dataOrParams?: any): Models.IPromised<T>;
    getArray(dataOrParams?: any): Models.IPromised<T[]>;
    query(dataOrParams?: any): Models.IPromised<T[]>;
    delete(dataOrParams?: any): Models.IPromised<T>;
    save(dataOrParams?: any): Models.IPromised<T>;
}

/*
 * Base Service to handle constructing custom RLResourceClass
 */
export class RLBaseService {
    constructor(private $baseResource: ng.resource.IResourceService) {

    }        // decorates $resource with post/postArray
    toRLService<T>(url: string, paramDefaults: any = {}): IRLResourceClass<T> {
        var output = this.$baseResource<T, IRLResourceClass<T>>(url, paramDefaults, RLActionDescriptions);
        return output;
    }
}